
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zoeken",
      function () {
        return require("private-next-pages/zoeken.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zoeken"])
      });
    }
  